'use client'

import { Loader } from '@vinted/web-ui'

import { UiState } from '@marketplace-web/shared/ui-state'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'

const ConversationLoader = () => {
  const { sendMessageUi } = useConversationContext()

  if (sendMessageUi.uiState !== UiState.Pending) return null

  return (
    <div className="conversation-loader__overlay">
      <div className="conversation-loader">
        <Loader
          styling={Loader.Styling.Lifted}
          size={Loader.Size.Large}
          testId="conversation-loader"
        />
      </div>
    </div>
  )
}

export default ConversationLoader
